import 'focus-visible';

const INPUT_CHIP_CLASS = 'at-input-chip';
const INPUT_CHIP_HIDDEN_CLASS = `${INPUT_CHIP_CLASS}--hidden`;

const hideChip = (itemId) => {
  const chip = document.getElementById(itemId);
  if (chip !== null) {
    chip.classList.add(INPUT_CHIP_HIDDEN_CLASS);
  }
};

const showChip = (itemId) => {
  const chip = document.getElementById(itemId);
  if (chip !== null) {
    chip.classList.remove(INPUT_CHIP_HIDDEN_CLASS);
    chip.setAttribute('aria-checked', 'true');
  }
};

const initializeInputChips = () => {
  const inputChips = document.querySelectorAll(`.${INPUT_CHIP_CLASS}`);
  inputChips.forEach((chip) => {
    const id = chip.getAttribute('id');
    chip.addEventListener('click', () => hideChip(id));
  });
};

export {
  hideChip,
  showChip,
  initializeInputChips,
};